import { ClientRepo } from "@services/clients/client.repo";
import { AuthService } from "@common/auth.service";

class ClientFeeManagementController implements ng.IOnInit, ng.IOnChanges {
  public clients;
  public selectedClient;
  public searchText: string;
  public clientDetails;
  public isLoadingClientDetails: boolean = false;
  /** When false, client selector is hidden and client is passed in via binding (e.g. client details). Defaults to true when not bound. */
  public searchClients: boolean;
  /** When false, fee-cards/debit-accounts/exclusions are read-only. Used when embedded in client details. Defaults to false when not bound. */
  public canEdit: boolean = false;
  /** Optional callback when embedded (e.g. in client details). Called when fees/debit-accounts/exclusions are refreshed so parent can update its data. */
  public onRefresh: () => void;

  /** @ngInject */
  constructor(
    private clientRepo: ClientRepo,
    private notifyjs,
    private authService: AuthService
  ) {}

  $onInit = () => {
    // When used without bindings (e.g. route), searchClients is undefined → treat as true
    if (this.searchClients === undefined) {
      this.searchClients = true;
    }
    if (this.searchClients !== false) {
      this.getClients();
    }
  };

  $onChanges = (changes: ng.IOnChangesObject) => {
    const clientChange = changes["client"];
    if (
      clientChange &&
      this.searchClients === false &&
      clientChange.currentValue &&
      clientChange.currentValue.clientNumber
    ) {
      this.selectedClient = clientChange.currentValue;
      // Use passed-in client directly so fee-cards get it immediately (no extra getClient() call)
      this.clientDetails = clientChange.currentValue;
    }
  };

  /** Called when client dropdown opens. Clears search text only; clients are fetched on init when searchClients is true. */
  onClientDropdownOpen = () => {
    this.clearSearchText();
  };

  getClients = () => {
    this.isLoadingClientDetails = true;
    this.clientRepo
      .searchClients({
        orderColumn: "clientNumber",
        orderDirection: "asc",
        displayAllClients: true
      })
      .then((res) => {
        let data = res.data as any;
        this.clients = data.results as Array<any>;
        this.isLoadingClientDetails = false;
      })
      .catch((err) => {
        this.notifyjs("Failed to load client details");
        this.isLoadingClientDetails = false;
      });
  };

  getClientFees = () => {
    if (this.selectedClient) {
      if (this.searchClients === false) {
        // Client was passed in (e.g. from client details page); keep using it, no extra API call
        this.clientDetails = this.selectedClient;
        if (this.onRefresh) {
          this.onRefresh();
        }
      } else {
        // Standalone fee management: fetch full client details for child components
        this.clientDetails = null;
        this.isLoadingClientDetails = true;
        this.getClient();
      }
    }
  };

  canAccessClientDetails = (): boolean => {
    return this.authService.canAccessClientDetails();
  };

  clearSearchText = () => {
    this.searchText = "";
  };

  getClient = () => {
    this.clientRepo.getClient(this.selectedClient.clientNumber).then((res) => {
      this.clientDetails = res.data;
      this.isLoadingClientDetails = false;
    }).catch(() => {
      this.notifyjs("Failed to load client details");
      this.isLoadingClientDetails = false;
    });
  };
}

export const clientFeeManagement: ng.IComponentOptions = {
  template: require("./fees.clientFeeManagement.html"),
  controller: ClientFeeManagementController,
  bindings: {
    /** When true (default), show client selector and fetch clients when dropdown opens. When false, client is passed in via client binding. */
    searchClients: "<",
    /** Pre-selected client when used in context where client is already known (e.g. client details). Used when searchClients is false. */
    client: "<",
    /** When true, fee-cards/debit-accounts/exclusions are editable. Used when embedded in client details. Defaults to false. */
    canEdit: "<",
    /** Optional. Called when fees/debit-accounts/exclusions are refreshed (e.g. after add/edit). Used when embedded so parent can update. */
    onRefresh: "&",
  },
};



// WEBPACK FOOTER //
// ./src/app/fees/clientFeeManagement/fees.clientFeeManagement.ts